"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconButton = exports.StyledCloseButtonContainer = exports.StyledAlertMessage = exports.StyledAlertHeading = exports.StyledAlertContentContainer = exports.StyledAlertContent = exports.StyledAlert = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../../../lib/components/fuse-buttons/src/buttons");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
var _config = _interopRequireDefault(require("./config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledAlert = exports.StyledAlert = (0, _styledComponents["default"])(_grid.GridRow).attrs({
  className: 'fuse-alert'
}).withConfig({
  displayName: "styled-alert__StyledAlert",
  componentId: "sc-1hdgkqs-0"
})(["border-radius:var(--brand-border-radius,6px);", " padding:var(--spacing-global-space4) var(--spacing-global-space5);", ""], function (props) {
  return "\n\t\tbackground: ".concat(_config["default"][props.variant].background, ";\n\n\t\t").concat(props.banner ? "grid-template-columns: repeat(11,1fr) 32px;" : "grid-template-columns: repeat(12,1fr);", "\n\t\t\n\t");
}, function (props) {
  return props.size === 'responsive' && "\n\t\t@media screen and (min-width: ".concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\tpadding: var(--spacing-global-space4) var(--spacing-global-space5);\n\t\t}\n\n\t\t@media screen and (min-width: ").concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\tpadding: var(--spacing-global-space5) var(--spacing-global-space6);\n\t\t}\n\t");
});
var StyledAlertHeading = exports.StyledAlertHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-alert__heading',
  'data-testid': 'fuse-alert__heading',
  type: 'heading',
  size: {
    xxs: 'm1',
    m: '1',
    l: '2'
  }
}).withConfig({
  displayName: "styled-alert__StyledAlertHeading",
  componentId: "sc-1hdgkqs-1"
})(["margin-bottom:var(--spacing-global-space2);&:last-child{margin:0;}"]);
var StyledAlertMessage = exports.StyledAlertMessage = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-alert__message',
  'data-testid': 'fuse-alert__message',
  type: 'paragraph',
  size: 'm1'
}).withConfig({
  displayName: "styled-alert__StyledAlertMessage",
  componentId: "sc-1hdgkqs-2"
})(["color:var(--color-global-black);margin:0 0 var(--spacing-global-space3);&:last-child{margin:0;}"]);
var StyledAlertContentContainer = exports.StyledAlertContentContainer = (0, _styledComponents["default"])(_grid.GridItem).attrs({
  className: 'fuse-alert__content-container',
  'data-testid': 'fuse-alert__content-container'
}).withConfig({
  displayName: "styled-alert__StyledAlertContentContainer",
  componentId: "sc-1hdgkqs-3"
})(["", ""], function (_ref) {
  var showIcon = _ref.showIcon,
    size = _ref.size,
    variant = _ref.variant;
  return "\n\t\tdisplay:grid;\n\t\tgrid-template-columns: ".concat(showIcon ? 'var(--spacing-global-space7) auto' : 'auto', ";\n\t\tgrid-column-gap: var(--spacing-global-space3);\n\n\t\t").concat(showIcon ? "\n\t\t\t&::before {\n\t\t\t\tdisplay: grid;\n\t\t\t\tcontent: '';\n\t\t\t\tmask: url('data:image/svg+xml,".concat(encodeURIComponent(_config["default"][variant].icon), "') top left/contain\n\t\t\t\t\tno-repeat;\n\t\t\t\t-webkit-mask: url('data:image/svg+xml,").concat(encodeURIComponent(_config["default"][variant].icon), "') top left/contain\n\t\t\t\t\tno-repeat;\n\t\t\t\tbackground: ").concat(_config["default"][variant].iconColour, ";\n\t\t\t}\n\t\t") : "", "\n\t\t\n\t\t").concat(size === 'responsive' && "\n\t\t\t@media screen and (min-width: ".concat(_grid.gridConfig.l.minWidth, ") {\n\t\t\t\tgrid-column-gap: var(--spacing-global-space5);\n\t\t\t}\n\t\t"), "\n\t");
});
var StyledAlertContent = exports.StyledAlertContent = _styledComponents["default"].div.attrs({
  className: 'fuse-alert__content',
  'data-testid': 'fuse-alert__content'
}).withConfig({
  displayName: "styled-alert__StyledAlertContent",
  componentId: "sc-1hdgkqs-4"
})(["display:flex;flex-direction:column;min-height:var(--spacing-global-space7);justify-content:center;"]);
var StyledCloseButtonContainer = exports.StyledCloseButtonContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-alert__close-button-container',
  'data-testid': 'fuse-alert__close-button-container'
}).withConfig({
  displayName: "styled-alert__StyledCloseButtonContainer",
  componentId: "sc-1hdgkqs-5"
})(["display:grid;height:fit-content;justify-content:flex-end;@media screen and (min-width:", "){grid-column-start:12;}"], _grid.gridConfig.l.minWidth);
var StyledIconButton = exports.StyledIconButton = (0, _styledComponents["default"])(_buttons.PlainIconButton).attrs({
  className: 'fuse-alert__close-button',
  'data-testid': 'fuse-alert__close-button'
}).withConfig({
  displayName: "styled-alert__StyledIconButton",
  componentId: "sc-1hdgkqs-6"
})([""]);